import type { CursorUserInfo } from '../../../../client';
import { useUserData } from '../../../../hooks/useUserData';
import FireflyInfoModal from '../../../../ui/modals/FireflyInfoModal';

interface FireflyInfoHostProps {
  /* MapCanvas-owned local useState — not store-backed. */
  fireflyPopup: CursorUserInfo | null;
  fireflyPopupLoading: boolean;
  fireflyRecordedAt: number | null;
  setFireflyPopup: (value: CursorUserInfo | null) => void;
  setFireflyPopupLoading: (value: boolean) => void;
}

/** Firefly replay info popup. userData via useUserData. */
export default function FireflyInfoHost({
  fireflyPopup,
  fireflyPopupLoading,
  fireflyRecordedAt,
  setFireflyPopup,
  setFireflyPopupLoading,
}: FireflyInfoHostProps) {
  const { data: userData } = useUserData();

  return (
        <FireflyInfoModal
          info={fireflyPopup}
          isLoading={fireflyPopupLoading}
          recordedAt={fireflyRecordedAt}
          isAdmin={!!userData?.is_admin}
          onClose={() => { setFireflyPopup(null); setFireflyPopupLoading(false); }}
        />
  );
}
